import { styled, useStyletron } from 'baseui';
import { Banner, KIND } from 'baseui/banner';
import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as IntroductionIcon } from '../../../../assets/img/quizzes/introduction.svg';
import {
  BannerContent,
  BannerTitle,
  BannerWrapper,
} from './StyledComponents';

const BannerIconWrapper = styled('div', ({ $theme }) => ({
  '.info-banner__icon path': {
    fill: $theme.colors.notificationInfoText,
  },
}));


const getBannerOverrides = (theme, width, padding) => ({
  Root: {
    style: {
      backgroundColor: theme.colors.notificationInfoBackground,
      borderRadius: '16px',
      margin: '0px',
      width,
      maxWidth: '100%',
      gap: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
  },
  Title: {
    style: {
      color: theme.colors.notificationInfoText,
    },
  },
  Message: {
    style: {
      color: theme.colors.notificationInfoText,
      fontWeight: 400
    },
  },
  MessageContent: {
    style: {
      ...(padding ? { padding } : {})
    },
  },
});

const InfoBanner = ({ message, title, action, width = '100%', padding = null, showIcon = true }) => {
  const [css, theme] = useStyletron();

  return (
    <BannerWrapper>
      <Banner
        title={<BannerTitle>{title}</BannerTitle>}
        kind={KIND.positive}
        action={action}
        artwork={{
          icon: () => showIcon ? (
            <BannerIconWrapper>
              <IntroductionIcon className="info-banner__icon" />
            </BannerIconWrapper>
          ) : null,
        }}
        overrides={getBannerOverrides(theme, width, padding)}
      >
        <BannerContent>
          <span>{message}</span>
        </BannerContent>
      </Banner>
    </BannerWrapper>
  );
};

InfoBanner.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  action: PropTypes.object,
  width: PropTypes.string,
  padding: PropTypes.string,
};

export default InfoBanner;
